import InputControl from "@shared/components/form/InputControl";
import { Button } from "@shared/components/ui/Button";
import React, { useState } from "react";
import { CreateInvitationRequest } from "../types/invitation";

interface InvitationFormProps {
  onSubmit: (data: CreateInvitationRequest) => void;
  isLoading: boolean;
  title?: string;
  description?: string;
  role?: string;
  onImportClick?: () => void;
}

export const roleOptions = [{ value: "member", label: "Member" }];

export const InvitationForm: React.FC<InvitationFormProps> = ({
  onSubmit,
  isLoading,
  title = "Invite Team Members",
  description,
  role = "member",
  onImportClick,
}) => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({ email, role });
    setEmail("");
  };

  return (
    <div className="py-6 mb-6">
      <h3 className={`text-lg font-semibold ${description ? "mb-1" : "mb-4"}`}>{title}</h3>
      {description && (
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-4 max-w-3xl">{description}</p>
      )}
      <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
        <div className="">
          <InputControl
            id="email"
            name="email"
            label="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter email address"
            type="email"
            required={true}
          />
        </div>
        <div className="flex gap-2 items-end">
          <Button
            className="mt-[26px]"
            type="submit"
            disabled={isLoading || !email}
            isLoading={isLoading}
            loadingText="Sending..."
            variant="primary"
          >
            Send Invitation
          </Button>
          {onImportClick && (
            <Button
              className="mt-[26px]"
              type="button"
              variant="secondary"
              onClick={onImportClick}
            >
              Import Contacts
            </Button>
          )}
        </div>
      </form>
    </div>
  );
};
